<template>
  <v-dialog max-width="500px" persistent v-model="dialog" scrollable>
    <v-card v-if="selectedCustomer != null">
      <v-toolbar dark>
        <v-toolbar-title class="headline">Edit Customer</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false)">close</v-icon>
      </v-toolbar>
      <v-card-text style="height: auto;">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row>
            <v-flex>
              <v-layout row>
                <v-flex xs2 class="mr-2">
                  <v-select
                    :items="country_tel"
                    v-model="selectedCustomer.user_country_tel"
                    label="Select"
                  ></v-select>
                </v-flex>
                <v-flex xs10 class="ml-2">
                  <v-text-field
                    mask="## - ### - ####"
                    v-model="selectedCustomer.user_tel"
                    label="Tel."
                    :rules="[telValid.leng,telValid.already,telValid.required]"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 class="mr-2">
                  <v-text-field
                    v-model="selectedCustomer.user_first_name"
                    label="First name"
                    :rules="[nameValid.max,nameValid.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 class="ml-2">
                  <v-text-field
                    v-model="selectedCustomer.user_last_name"
                    label="Last name"
                    :rules="[nameValid.max,nameValid.required]"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-text-field
                v-model="selectedCustomer.user_email"
                label="Email"
                :rules="[emailValid.email,emailValid.required,emailValid.already]"
              ></v-text-field>

              <div class="line-changepass"></div>
              <v-text-field
                v-model="password1"
                :append-icon="show1 ? 'visibility_off' : 'visibility'"
                :type="show1 ? 'text' : 'password'"
                name="input-1"
                label="New Password"
                hint="At least 6 characters and No more than 24 characters"
                class="input-group--focused"
                @click:append="show1 = !show1"
              ></v-text-field>
              <v-text-field
                v-model="password2"
                :append-icon="show2 ? 'visibility_off' : 'visibility'"
                :type="show2 ? 'text' : 'password'"
                name="input-2"
                label="Confirm Password"
                hint="At least 6 characters and No more than 24 characters"
                class="input-group--focused"
                @click:append="show2 = !show2"
              ></v-text-field>
              <div v-if="passwordMatch == false">Password Not match ...</div>
            </v-flex>
            <!-- <v-flex xs6 class="ml-2">
                        <v-card-text>
                            <h1 style="font-size:22px;">Address Information</h1>
                            <v-textarea name="address" label="Address" value="" hint="Hint text" rows="1"></v-textarea>
                            <v-layout row>
                                <v-flex xs6 class="mr-2">
                                    <v-text-field v-model="selectedCustomer.user_first_name" label="First name" :rules="[nameValid.max,nameValid.required]"></v-text-field>
                                </v-flex>
                                <v-flex xs6 class="ml-2">
                                    <v-text-field v-model="selectedCustomer.user_last_name" label="Last name" :rules="[nameValid.max,nameValid.required]"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-text-field v-model="selectedCustomer.user_email" label="Email" :rules="[emailValid.email,emailValid.required,emailValid.already]"></v-text-field>
                        
                            <div class="line-changepass"></div>
                            <v-text-field v-model="password1" :append-icon="show1 ? 'visibility_off' : 'visibility'" :type="show1 ? 'text' : 'password'" name="input-1" label="New Password" hint="At least 6 characters and No more than 24 characters" class="input-group--focused" @click:append="show1 = !show1"></v-text-field>
                            <v-text-field v-model="password2" :append-icon="show2 ? 'visibility_off' : 'visibility'" :type="show2 ? 'text' : 'password'" name="input-2" label="Confirm Password" hint="At least 6 characters and No more than 24 characters" class="input-group--focused"
                                @click:append="show2 = !show2"></v-text-field>
                            <div v-if="passwordMatch == false"> Password Not match ...</div>
    
                        </v-card-text>
                    </v-flex>
                    < <v-flex xs6 class="ml-2">
                            <v-card-text>
                                <h1 style="font-size:22px;">Address Information</h1>
                                <v-textarea name="address" label="Address" value="" hint="Hint text" rows="1"></v-textarea>
                                <v-layout row>
                                    <v-flex xs6 class="mr-2">
                                        <v-select :items="districtItems" item-text="name" label="District"></v-select>
                                    </v-flex>
                                    <v-flex xs6 class="ml-2">
                                        <v-select :items="subDistrictItems" item-text="name" label="Sub district"></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs6 class="mr-2">
                                        <v-select :items="provinceItems" item-text="name" label="Province"></v-select>
                                    </v-flex>
                                    <v-flex xs6 class="ml-2">
                                        <v-select :items="postcodeItems" item-text="name" label="Post Code"></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-textarea name="note" label="Place Note" value="" hint="Hint text" rows="3"></v-textarea>
                                <v-card height="200px" width="auto" color="grey">pin location</v-card>
                            </v-card-text>
            </v-flex>-->
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" flat @click="cancel()">Cancel</v-btn>
        <v-btn color="green" flat @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["dialog", "selectedCustomer", "original"],
  data() {
    return {
      country_tel: ["+66"],
      passwordMatch: true,
      districtItems: [
        {
          name: "districtItems1",
          value: 1
        },
        {
          name: "districtItems2",
          value: 2
        }
      ],
      subDistrictItems: [
        {
          name: "subDistrictItems1",
          value: 1
        },
        {
          name: "subDistrictItems2",
          value: 2
        }
      ],
      provinceItems: [
        {
          name: "Phuket",
          value: 1
        },
        {
          name: "Trang",
          value: 2
        }
      ],
      postcodeItems: [
        {
          name: "12345",
          value: 1
        },
        {
          name: "56789",
          value: 2
        }
      ],
      password1: "",
      password2: "",
      show1: false,
      show2: false,
      valid: true,
      telValid: {
        required: value => !!value || "Required.",
        leng: v => v.length == 9 || "9 characters",
        already: a => !this.telAlready(a) || "Already in use"
      },
      nameValid: {
        required: value => !!value || "Required.",
        max: v => v.length <= 55 || "Min 55 characters"
      },
      emailValid: {
        already: a => !this.emailAlready(a) || "Already in use",
        required: value => !!value || "Required.",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
      roleValid: {
        required: value => !!value || "Required."
      },
      passwordValid: {
        min: v => v.length >= 6 || "At least 6 characters",
        max: v => v.length <= 24 || "No more than 24 characters"
      }
    };
  },
  watch: {
    password1() {
      if (this.password1.length > 5 && this.password1.length < 25) {
        if (this.password1 != this.password2) {
          this.passwordMatch = false;
        } else {
          this.passwordMatch = true;
        }
      } else {
        this.passwordMatch = true;
      }
    },
    password2() {
      if (this.password2.length > 5 && this.password2.length < 25) {
        if (this.password1 != this.password2) {
          this.passwordMatch = false;
        } else {
          this.passwordMatch = true;
        }
      } else {
        this.passwordMatch = true;
      }
    }
  },
  computed: {
    ...mapState({
      customerData: state => state.fetchCustomerBack.customerData
    })
  },
  methods: {
    telAlready(a) {
      let check = 0;
      let ID2 = this.selectedCustomer.user_id;
      for (let key in this.customerData) {
        if (this.customerData[key].user_id != ID2) {
          if (a == this.customerData[key].user_tel) {
            check = 1;
          }
        }
      }
      if (check == 0) {
        return false;
      } else if (check == 1) {
        return true;
      }
    },
    emailAlready(a) {
      let check = 0;
      let ID1 = this.selectedCustomer.user_id;
      for (let key in this.customerData) {
        if (this.customerData[key].user_id != ID1) {
          if (a == this.customerData[key].user_email) {
            check = 1;
          }
        }
      }
      if (check == 0) {
        return false;
      } else if (check == 1) {
        return true;
      }
    },
    cancel() {
      Object.assign(this.selectedCustomer, this.original);
      this.$emit("setDialog", false);
      this.$emit("cancel");
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.$emit("setDialog", false);
        let index = this.customerData.indexOf(this.selectedCustomer);
        this.$store.commit("fetchCustomerBack/editing", index);
        const sendData = {
          user_country_tel: this.selectedCustomer.user_country_tel,
          user_email: this.selectedCustomer.user_email,
          user_facebook_id: this.selectedCustomer.user_facebook_id,
          user_first_name: this.selectedCustomer.user_first_name,
          user_id: this.selectedCustomer.user_id,
          user_last_name: this.selectedCustomer.user_last_name,
          user_role: this.selectedCustomer.user_role,
          user_sum_point: this.selectedCustomer.user_sum_point,
          user_tel: this.selectedCustomer.user_tel,
          user_type: this.selectedCustomer.user_type,
          user_verify: this.selectedCustomer.user_verify
        };
        let checkSuccess = await this.$store.dispatch(
          "fetchCustomerBack/editCustomer",
          sendData
        );
        if (checkSuccess == "error") {
          Object.assign(this.selectedCustomer, this.originalUser);
        }
        if (this.password1.length > 5 && this.password1.length < 25) {
          if (this.passwordMatch == true) {
            const sendData = {
              user_id: this.selectedCustomer.user_id,
              new_password: this.password2
            };
            this.$store.dispatch("fetchUserBack/changePasswordUser", sendData);
          }
        }
        this.$emit("cancel");
        this.password1 = "";
        this.password2 = "";
      }
    }
  }
};
</script>

<style>
.line-changepass {
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 2px solid black;
  color: #333;
  text-align: center;
  margin-top: 25px;
}

.line-changepass:after {
  content: "Change Password";
  display: inline-block;
  position: relative;
  top: -0.8em;
  font-size: 17px;
  padding: 0 0.25em;
  background: white;
}
</style>

